import { Field, useFormikContext } from 'formik';

import { SupportingDocumentSourceList } from '../../config/supportingDocument';
import { FormErrorUI, FormLabelUI, InputUI, SelectUI } from '../Interface';

const supportingDocumentSourceOptions = Object.entries(SupportingDocumentSourceList).map(([value, label]) => ({
  value,
  label,
}));

const SupportingDocumentTypeFields = ({ viewField }) => {
  const { values, errors, setFieldValue } = useFormikContext();

  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-4 col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.name) }}
        />
      </div>
      <div className="md:col-span-4 col-span-4">
        <Field
          type="text"
          name="note"
          as={InputUI}
          fullWidth
          multiline
          minRows={3}
          label={<FormLabelUI text="Megjegyzés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.note} />}
          disabled={viewField}
          InputLabelProps={{ shrink: Boolean(values.note) }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="generated"
          as={SelectUI}
          label={<FormLabelUI text="Típus" />}
          option={[
            { value: true, label: 'Generált' },
            { value: false, label: 'Külső' },
          ]}
          disabled={viewField}
          helperText={<FormErrorUI message={errors.generated} />}
          onChange={(event) => {
            const generated = event.target.value;
            setFieldValue('generated', generated);
            if (!generated) setFieldValue('prefix', null);
            if (generated) setFieldValue('source', null);
          }}
        />
      </div>
      {values.generated && (
        <div className="md:col-span-2 col-span-4">
          <Field
            type="text"
            name="prefix"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Sorszámprefix" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.prefix} />}
            disabled={viewField}
            InputLabelProps={{ shrink: Boolean(values.prefix) }}
          />
        </div>
      )}
      {!values.generated && (
        <div className="md:col-span-2 col-span-4">
          <Field
            name="source"
            as={SelectUI}
            label={<FormLabelUI text="Forrás" />}
            option={supportingDocumentSourceOptions}
            disabled={viewField}
            helperText={<FormErrorUI message={errors.source} />}
            onClear={() => setFieldValue('source', null)}
          />
        </div>
      )}
    </div>
  );
};

export default SupportingDocumentTypeFields;
